/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates 3D radio buttons
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function Radio({
    current,
    disabled = false,
    checkedColor = "#0366b2",
    uncheckedColor = "#737373",
    labels,
    fontColor = "#c6c6c6",
    setRadio,
    textWidth,
    textSize = "p1",
    textSizeDecimal,
    radius = 0.1,
    aframeClasses,
    ...otherAttributes
}) {
    const radioClickHandler = (label) => {
        if (disabled) return;
        if (label !== current) {
            setRadio(label);
        }
    };
    const generateButtons = () => {
        return labels.map((label, index) => {
            const isChecked = current === label;
            return (
                <a-ring
                    onClick={() => radioClickHandler(label)}
                    key={index}
                    color={
                        disabled || !isChecked ? uncheckedColor : checkedColor
                    }
                    radius-inner={radius * 0.9}
                    radius-outer={radius}
                    position={`0 ${index * radius * -3} 0`}
                    opacity={disabled ? "0.5" : "1"}
                    class={aframeClasses}
                >
                    <a-circle
                        color={disabled ? uncheckedColor : checkedColor}
                        radius={radius / 2}
                        visible={isChecked}
                        opacity={disabled ? "0.5" : "1"}
                        class={aframeClasses}
                    />
                    <a-plane
                        width={textWidth}
                        height={radius * 2}
                        position={`${radius * 2 + textWidth / 2} 0 0`}
                        class={aframeClasses}
                        visible={false}
                    />
                    <Text
                        color={fontColor}
                        align="left"
                        width={textWidth}
                        position={`${radius * 2} 0 0`}
                        text={label}
                        size={textSize}
                        sizeDecimal={textSizeDecimal}
                        opacity={disabled ? "0.5" : "1"}
                    />
                </a-ring>
            );
        });
    };

    return (
        <a-entity class="Radio" {...otherAttributes}>
            {generateButtons()}
        </a-entity>
    );
}

Radio.propTypes = {
    current: PropTypes.string.isRequired,
    labels: PropTypes.array.isRequired,
    textWidth: PropTypes.PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};

export default Radio;
